import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=01b5d340&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=01b5d340&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b5d340",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/muying-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01b5d340')) {
      api.createRecord('01b5d340', component.options)
    } else {
      api.reload('01b5d340', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=01b5d340&scoped=true", function () {
      api.rerender('01b5d340', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/coreProduct/coreCreatStore/detail.vue"
export default component.exports